import { render } from "./CoLink.vue?vue&type=template&id=9476f5ba&scoped=true"
import script from "./CoLink.vue?vue&type=script&lang=js"
export * from "./CoLink.vue?vue&type=script&lang=js"

import "./CoLink.vue?vue&type=style&index=0&id=9476f5ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9476f5ba"]])

export default __exports__